import React from 'react';
import PublicationTimeline from '../components/PublicationTimeline';

const PublicationPage = () => (
    <>
        <h2 className="page-heading">Publications</h2>
        <PublicationTimeline />
    </>
    
)

export default PublicationPage;